// core
import { inject, Injector } from '@angular/core';
import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';

// states
import { AuthState } from '@data/state';
import { Store } from '@ngxs/store';

// services
import { SweetAlertService } from '@app/service';

export const baseHttpInterceptor: HttpInterceptorFn = (req, next) => {
    const injector = inject(Injector);
    const store = injector.get(Store);
    const sweetAlertService = injector.get(SweetAlertService);
    const baseUrl = injector.get('BASE_URL', '');

    const token = store.selectSnapshot(AuthState.token);
    const tenantId = store.selectSnapshot(AuthState.tenantId);

    let modifiedReq = req;
    if (token) {
        const headers: { [key: string]: string } = {
            Authorization: `Bearer ${token}`,
        };
        if (tenantId) {
            headers['tenantId'] = tenantId;
        }
        modifiedReq = req.clone({
            setHeaders: headers,
        });
    }

    return next(modifiedReq).pipe(
        catchError((error: HttpErrorResponse) => {
            if (error) {
                switch (error.status) {
                    case 400:
                        let parsedError = error.error;
                        if (req.responseType === 'text' && error.error) {
                            try {
                                parsedError = JSON.parse(error.error as string);
                            } catch (e) {
                                // Ignore parse errors
                            }
                        }

                        if (parsedError?.errors) {
                            const modalStateErrors = [];
                            for (const key in parsedError.errors) {
                                if (parsedError.errors[key]) {
                                    modalStateErrors.push(parsedError.errors[key]);
                                }
                            }
                            sweetAlertService.error(modalStateErrors.flat().toString());
                            throw modalStateErrors.flat();
                        } else if (typeof parsedError === 'object') {
                            sweetAlertService.error(parsedError.message);
                        } else {
                            sweetAlertService.error(parsedError);
                        }
                        break;
                    case 401:
                        if (req?.url === `${baseUrl}/auth/login`) {
                            sweetAlertService.error(error.error.message);
                            break;
                        }

                        sweetAlertService.unauthorized(
                            'Your session has ended. Please login again to continue',
                            'Back to sign in',
                        );
                        break;
                    case 404:
                        sweetAlertService.error(error.error.message);
                        break;
                    case 412:
                        sweetAlertService.error(error.error.message);
                        break;
                    case 409:
                        sweetAlertService.error(error.error.message);
                        break;
                    case 500:
                        sweetAlertService.error(error.error.message);
                        break;
                    default:
                        sweetAlertService.error('Something went wrong');
                        console.log(error);
                        break;
                }
            }
            return throwError(() => error);
        }),
    );
};
